import axios from '@/lib/AxApi';

export default
{
    selectMyChats(params, cb)
    {
        axios.get('/rest/WorkOrderTalks/selectMyChats',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    selectChat(params, cb)
    {
        axios.get('/rest/WorkOrderTalks/selectChat',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    selectAllWorkOrderChats(params, cb)
    {
        axios.get('/rest/WorkOrderTalks/selectAllWorkOrderChats',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    insertTalk(params, cb)
    {
        axios.post('/rest/WorkOrderTalks/insertRow', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    selectChatByDentalSolutionId(params, cb)
    {
        axios.get('/rest/WorkOrderTalks/selectChatByDentalSolutionId',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    selectAllDentalSolutionChats(params, cb)
    {
        axios.get('/rest/WorkOrderTalks/selectAllDentalSolutionChats',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
}


// WEBPACK FOOTER //
// ./src/api/workordertalks.js